import GenderSelect from './GenderSelect'

export default GenderSelect
